import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule, DatePipe } from '@angular/common';
import { CardModule, HeroImageModule, PaginationModule, SubscriptionFormModule } from '../../shared/components';
import { FileModule } from '../../shared/pipes';
import { CoursesComponent } from './courses.component';
import { CentersComponent } from './centers/centers.component';
import { CenterComponent } from './centers/center/center.component';
import { TranslateModule } from '@ngx-translate/core';
import { FilePipe } from '../../shared/pipes/file/file.pipe';

const routes: Routes = [
  { path: '', component: CoursesComponent },
  { path: 'centers', component: CentersComponent },
  { path: 'centers/:id', component: CenterComponent },
  { path: ':id', loadChildren: () => import('./course/course.module').then(m => m.CourseModule) }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    CardModule,
    PaginationModule,
    FileModule,
    SubscriptionFormModule,
    TranslateModule,
    HeroImageModule
  ],
  declarations: [CoursesComponent, CentersComponent, CenterComponent],
  providers: [
    FilePipe,
    DatePipe
  ]
})
export class CoursesModule {
}
